/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
window.customization_event = false;
final_customized_pdp_url = '';
function setValueIfExists(id, value) {
  const el = document.getElementById(id);
  if (el) el.value = value;
}

function markSelectedSwatchByTag(variantTagValue) {
  // Remove 'selected-swatch' from all .block-swatch__item inside .swatch-v2
  document.querySelectorAll('.swatch-v2 .block-swatch__item').forEach(function(el) {
    el.classList.remove('selected-swatch');
  });

  // Find the swatch-v2 element with matching data-variant-tag
  const swatch = document.querySelector(`.swatch-v2[data-variant-tag="${variantTagValue}"]`);
  if (swatch) {
    const label = swatch.querySelector('.block-swatch__item');
    if (label) {
      label.classList.add('selected-swatch');
    }
  }

  if (variantTagValue === "leave-blank") {
    setValueIfExists('v2-customized', 'no');
    setValueIfExists("main-product-art-work-url", "");
    setValueIfExists("main-product-art-work-cords", "");
    setValueIfExists("main-product-customized-url", "");
  }

  else if (variantTagValue === "add-custom-text") {
    setValueIfExists('v2-customized', 'yes');
    setValueIfExists("main-product-art-work-url", "");
    setValueIfExists("main-product-art-work-cords", "");
    setValueIfExists("main-product-customized-url", "");
  }

  else if (variantTagValue === "add-photo") {
    setValueIfExists('v2-customized', 'photo');
  }

}

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.swatch-v2').forEach(function (el) {
    el.addEventListener('click', function () {
      var data_variant_tag = this.getAttribute('data-variant-tag');
      
      if(data_variant_tag == "add-custom-text") {
          document.getElementById("customize-modal-element").click();
        }
      else {
         resetCustomization();
      }
      
    });
  });
});

document.addEventListener('variant:changed', function(event) {
  var variant = event.detail.variant;
  var element = document.getElementsByClassName("atc-block");

  if (variant.title == "Add Custom Text" && window.customization_event == false) {    
    if(element.length)
      element[0].classList.add("sticky-atc");
  }

  if (variant.title == "Leave Blank" || variant.title == "No Embroidery") {
    if(element.length)
      element[0].classList.remove("sticky-atc");
    resetCustomization();
  }

  setTimeout(update_price_atc, 1000);
 
});
function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
var url_param_customization_text = getParameterByName('customization_text');
var bulk_customizer_product_handle = getParameterByName('product_handle');


window.addEventListener("load", function(){
  if (url_param_customization_text) {
    trigger_customization(url_param_customization_text);
  }  

});

function buildShareProductUrl() {
  var u = window.final_customized_pdp_url;
  if (u && u.indexOf('http') === 0) return u;
  var b = window.location.href;
  if (b.indexOf('customization_text=') !== -1) return b;
  var c = document.getElementById('customized-words');
  var t = c ? c.value.replace(/^Your text:\s*/, '') : '';
  return t ? b + (b.indexOf('?') === -1 ? '?' : '&') + 'customization_text=' + encodeURIComponent(t) : b;
}

function submitShareForm(event) {

  event.preventDefault();

  _learnq.push(['identify', {
    // Change the line below to dynamically print the user's email.
    '$email' : document.getElementById("share_email").value
  }]);
   // Track presidential elections
  _learnq.push(['track', 'URL Shared', {
    'product_url' : buildShareProductUrl(),
    'product_image' : document.getElementById("share_image").src,
  }]);

  document.getElementById("share-form").style.display = "none";
  document.getElementById("share-success-message").style.display = "block";

  
  setTimeout(function(){
    document.getElementById("share-form").style.display = "block";
    document.getElementById("share-success-message").style.display = "none";
}, 4000);

}

if(document.getElementById('share-form'))
  document.getElementById('share-form').addEventListener('submit', submitShareForm);

var share_modal_cta = document.getElementById("share-modal-cta")

if(share_modal_cta) {

  share_modal_cta.addEventListener('click', function(event) {
    var img_elements = document.getElementsByClassName('product-gallery__image');
    var img_element = img_elements[0];
    console.log(img_element);
    document.getElementById("share_image").src = image_url;

  });
}

custom_variant_button = document.querySelector('.block-swatch__radio[value="Add Custom Text"]');

if (custom_variant_button) {
  custom_variant_button.addEventListener('click', function(event) {
    if (window.customization_event == false)
      document.getElementById("customize-modal-element").click();

    window.customization_event = false;
  });
}

document.addEventListener('click', function(event) {
  if (event.target.value == "autodeliver") {
    document.querySelectorAll('.shopify-payment-button')[0].style.display = 'none';
  } else if (event.target.value == "onetime") {
    document.querySelectorAll('.shopify-payment-button')[0].style.display = 'block';
  }
});

document.addEventListener('click', function (event) {
  if (document.querySelector('[data-action="open-filter"]') === event.target) {
    document.querySelector('.layout__section--secondary').classList.remove('hidden-pocket');
  }
}, {capture:true, passive:true});

if (document.querySelector('.layout__section--secondary')) {

  document.querySelector('.layout__section--secondary').addEventListener('click', function (event) {
    document.querySelector('.layout__section--secondary').classList.add('hidden-pocket');
  });
}

function resetCustomization() {
 
  if(is_v2) {
    var v2Element = document.getElementById('v2-customized');
    v2Element.value = 'no';
    markSelectedSwatchByTag("leave-blank");
  }

  if (printer_order_number_label_exist) {

    var order_label = "order_number";

    var t = "";

    for (i = 0; i < total_fields; i++) {
      t += "__";
    }

    if (customizer_printer_settings.hasOwnProperty('order_number_prefix')) {
      order_label = customizer_printer_settings['order_number_prefix'] + order_label;
    }

    if (customizer_printer_settings.hasOwnProperty('order_number_suffix')) {
      order_label = order_label + customizer_printer_settings['order_number_suffix'];
    }

    var t_printer = t + order_label;

    console.log(t_printer);
    

  }

  document.getElementById("customized-words").value = "";

  document.getElementById("customize-modal-element").textContent = "";
  document.getElementById("customized-text").textContent = "";
  var edit_block = document.getElementById("edit-customization-block");
  edit_block.style["display"] = "none";
  var img_elements = document.getElementsByClassName('product-gallery__image');
  var img_element = img_elements[0];

  if (old_product_img_html !== '')
    img_element.parentElement.innerHTML = window.old_product_img_html;

}


var p_images = document.getElementsByClassName("product-gallery__image");

for (var i = 0; i < p_images.length; i++) {

  var p_image = p_images[i];

  p_image.addEventListener("click", function() {
    location.hash = "#product_title";
  });
}


var customizer_modal = document.getElementById('modal-customize-product');

if (typeof customizer_modal != 'undefined' && customizer_modal != null) {
  customizer_modal.addEventListener('modal:closed', function() {
    var words = document.getElementById("customized-words").value;

    if (words == "") {
      resetCustomization();
      var result = document.querySelectorAll(".block-swatch__radio");
      var leave_blank = result[1];
      leave_blank.click();
    }
  });
}

function customizePhrase(event) {
  event.preventDefault();
  var customization_text_array = event.target.getAttribute("data-customization-text").split("|");
  var elmnt = document.getElementById("customized-image");
  elmnt.scrollIntoView()
  for (var i = 1; i <= total_fields; i++) {
    var current_field = document.getElementById("customize-text-" + i);
    if (customization_text_array[i - 1] !== undefined) {
      var char_limit = current_field.maxLength ? current_field.maxLength : 200;
      current_field.value = customization_text_array[i - 1].substr(0, char_limit).trim();
      current_field.classList.add("is-filled");

    } else {
      current_field.value = "";
    }
    updateCustomizedImage();
  }
  
  return;

  var img_elements = document.getElementsByClassName('product-gallery__thumbnail');
  var img_element = img_elements[0];
  
  img_element.click();
  event.preventDefault();
  trigger_customization(event.target.getAttribute("data-customization-text"));
}

// var all_phrases_container = document.querySelector("#order-note");

// if (typeof all_phrases_container != 'undefined' && all_phrases_container != null) {
//   var all_phrases = all_phrases_container.getElementsByTagName("li");

//   for (var i = 0, len = all_phrases.length; i < len; i++) {

//     all_phrases[i].addEventListener("click", function(event) {

//       event.preventDefault();
//       trigger_customization(event.target.getAttribute("data-customization-text"));

//     }, false);

//   }

// }

function trigger_customization(customization_text) {
  console.log("hello"+customization_text);

  window.customization_event = true;

  custom_variant_button.click();
  if(customization_text.includes("|"))
    var customization_text_array = customization_text.split("|").map(element => element.trim());
  else
    var customization_text_array = customization_text.split("__");
  console.log(customization_text_array)
  var element = document.getElementsByClassName("atc-block");
  if(element.length)
    element[0].classList.add("sticky-atc");

  for (var i = 1; i <= total_fields; i++) {
    var current_field = document.getElementById("customize-text-" + i);
    if (customization_text_array[i - 1] !== undefined) {
      var char_limit = current_field.maxLength ? current_field.maxLength : 200;
      current_field.value = customization_text_array[i - 1].substr(0, char_limit);
      current_field.classList.add("is-filled");

    } else {
      current_field.value = "";
    }

    updateCustomizedImage();
  }

  saveCustomization();
}




okeReviewsWidgetOnInit = function() {
  var stars = document.querySelectorAll(".js-okeReviews-reviewsSummary")
  stars.forEach(function(element){
    var count_reviews = element.parentNode.parentNode.dataset.reviews;
    
    element.querySelector('.okeReviews-reviewsSummary-ratingCount').innerText = element.querySelector('.okeReviews-a11yText').innerText.split(" ")[1] + " Stars ("+count_reviews+ " Reviews)";
    element.querySelector('.okeReviews-reviewsSummary-ratingCount').style.display = "inline-block";
  });
}


var top_phrases_head = document.getElementById("top-phrases-head");

if(top_phrases_head) {
  top_phrases_head.addEventListener("click", function(event) {
    var element = document.getElementById("top-phrases-main");
    var element2 = document.getElementsByClassName("atc-block");

    console.log(document.getElementById("order-note").getAttribute("aria-hidden"));
    
    if(document.getElementById("order-note").getAttribute("aria-hidden") == "true") {
     
      element.classList.add("open-popup");   
      element2[0].classList.add("sticky-atc");
      window.scrollTo(0, 130);
    }
    else {
      element2[0].classList.remove("sticky-atc");
      element.classList.remove("open-popup");
    }
    
    // aria-hidden order-note false true
    
   // var elmnt = document.getElementsByClassName("image-text-top-left");
   // elmnt[0].scrollIntoView();

  });

}

var p_qty_inputs = document.getElementsByClassName("product-form__quantity");

if (p_qty_inputs.length) {
  p_qty_inputs[0].addEventListener('change', function() {
   update_price_atc();
  });
}

function update_price_atc() {
  var qty_selector = document.getElementsByClassName("product-form__quantity")[0];
  var qty = qty_selector.value;

  var price_elems = document.getElementById("price--titlerow").getElementsByClassName("money");  

  if(price_elems[0] == undefined)
    return;
  var number = Number(price_elems[0].innerText.replace(/[^0-9.-]+/g,""));
  var final_price = qty*number;
  var customized_tag_id = document.getElementById("customized-text-tag");
  if(customized_tag_id && customized_tag_id.textContent) {
    final_price += qty*18;
  }
  var atc_block_class = document.getElementsByClassName("atc-block");

  var atc_block = document.getElementsByClassName("atc-block")[0];

  if (atc_block && !document.querySelectorAll(".block-swatch__radio")[0].checked) {

    var atc_button = atc_block.getElementsByClassName('product-form__add-button')[0];

    if (atc_button) {
      try {
        atc_button.innerHTML = "Add to cart &bull; " + Currency.formatMoney(final_price * 100, window.theme.moneyFormat);
      }
      catch (e) {
        console.trace('ATC button currency failed', atc_block, atc_button, Currency, final_price, window.theme.moneyFormat);
      }
  
    }

  }


}
// var carouselElement = document.querySelector('#mini-cart-carousel');
// window.flickity_1 = new Flickitynew(carouselElement, {
//   // Flickity options
//   contain: true,
//   pageDots: true,
//   prevNextButtons: false, // Disable Flickity's default navigation buttons
// });

// var bulk_customizer_link = document.getElementById("bulk-customizer");

// if (bulk_customizer_link) {
//   bulk_customizer_link.addEventListener("click", function (event) {
//     event.preventDefault();
//     var final_url =
//       bulk_customizer_link.href +
//       "&customizer_base_url=" +
//       btoa(window.customized_url) + "&force_caps="+force_caps + "&force_lower_caps="+force_lower_caps;
//     window.location.href = final_url;
//   });
// }

document.addEventListener("DOMContentLoaded", function () {
    // Select the first image with class product-gallery__image
    var firstImage = document.querySelector(".product-gallery__image");

    // Check if the first image exists
    if (firstImage) {
        // Add a click event listener to the first image
        firstImage.addEventListener("click", function () {
            // Select the element with class block-swatch__item and title "Add Custom Text"
            const lb_button_custom = document.querySelector('.block-swatch__item[title="Add Custom Text"]');
            
            // Check if the element exists before attempting to click
            if (lb_button_custom) {
                lb_button_custom.click();
            }
        });
    }
});


    function updateTimer() {
            // Get the current time in the Pacific Time Zone
            const now = new Date();
            const ptNow = new Date(now.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' }));

            // Set target time to 11 PM PT
            const target = new Date(ptNow);
            target.setHours(23, 0, 0, 0); // 11:00:00 PM PT

            // If it's already past 11 PM PT, set target time to 11 PM the next day
            if (ptNow > target) {
                target.setDate(target.getDate() + 1);
            }

            // Calculate the time difference between the current PT time and the target time
            const diff = target - ptNow;

            // Convert the difference to hours, minutes, and seconds
            const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((diff % (1000 * 60)) / 1000);

            // Get the element with id="timer"
            const timerElement = document.getElementById("timer");

            // Only update the timer if the element exists
            if (timerElement && hours > 0) {
                timerElement.innerHTML = 
                    `&nbsp;&nbsp;Order within ${hours} hrs ${minutes} mins ${seconds} secs <br />and upgrade to rush production to ship tomorrow.`;
            }
            else {
              timerElement.innerHTML = ""
            }
        }

        // Update the timer every second
       // setInterval(updateTimer, 1000);

        // Initialize the timer display
       // updateTimer();


// ============================================================================
// AUTO FREE GIFT: Add 1 free product per bag/tote purchased
// Created: November 25, 2025
// Updated: November 26, 2025 - Added price discount and reusable config
// Updated: March 27, 2026 - Detachable Crossbody Strap promo (Mar 28-30)
// ============================================================================

(function() {
  // ========== CONFIGURATION (Easy to update for future promos) ==========
  const FREE_GIFT_VARIANT_ID = 45105966317754; // Variant ID for Detachable Crossbody Strap (Product 8189690085562)
  const FREE_GIFT_ORIGINAL_PRICE = 1500; // Original price in cents (1500 = $15.00) - for display/strikethrough
  const FREE_GIFT_DISCOUNT_AMOUNT = 1500; // Discount in cents (1500 = $15.00 off = FREE)
  const PROMO_BAG_LIMIT = 0; // 0 = no limit
  const TRIGGER_PRODUCTS = ['bag', 'tote']; // Product titles containing these words trigger the promo
  // ======================================================================

  let isUpdatingFreeGift = false; // Prevent infinite loops
  let promoStillActive = true; // Assume active until we check

  // Function to check if a product title matches trigger keywords
  function isBagOrTote(productTitle) {
    if (!productTitle) return false;
    const lowerTitle = productTitle.toLowerCase();
    return TRIGGER_PRODUCTS.some(function(keyword) {
      return lowerTitle.includes(keyword);
    });
  }

  // Function to count total bags/totes in cart
  function countBagsInCart(cartData) {
    let totalBags = 0;

    cartData.items.forEach(function(item) {
      // Skip the free gift itself
      if (item.variant_id === FREE_GIFT_VARIANT_ID) return;

      // Check if product title contains "bag" or "tote"
      if (isBagOrTote(item.product_title)) {
        totalBags += item.quantity;
      }
    });

    return totalBags;
  }

  // Function to find free gift in cart
  function findFreeGift(cartData) {
    return cartData.items.find(function(item) {
      return item.variant_id === FREE_GIFT_VARIANT_ID;
    });
  }

  // Function to check if promo limit has been reached
  function checkPromoLimit() {
    // Check if promo limit has been reached via metaobject
    // Note: This needs to be injected via Liquid template (see layout/theme.liquid)
    // For now, we'll use a simple date-based check as fallback

    // Check if window.promoActive is set (will be set by Liquid)
    if (typeof window.promoActive !== 'undefined') {
      const isActive = window.promoActive;
      console.log('[Auto Free Gift] Promo active (from Liquid):', isActive);
      return Promise.resolve(isActive);
    }

    // Fallback: Simple date-based check
    // "An Upgrade On Us" promo: Mar 27-30, 2026 (live now for testing, runs through Sunday)
    const promoStartDate = new Date('2026-03-27T00:00:00-07:00'); // PST - moved up for testing
    const promoEndDate = new Date('2026-03-30T23:59:59-07:00'); // PST
    const now = new Date();
    const isActive = now >= promoStartDate && now <= promoEndDate;

    console.log('[Auto Free Gift] Promo active (date-based fallback):', isActive);

    return Promise.resolve(isActive);
  }

  // Function to update free gift quantity
  function updateFreeGift() {
    if (isUpdatingFreeGift) return; // Prevent loops

    isUpdatingFreeGift = true;

    // First check if promo is still active
    checkPromoLimit()
      .then(function(isActive) {
        promoStillActive = isActive;

        if (!isActive) {
          // Promo limit reached - remove free gift if present
          return fetch(window.routes.cartUrl + '.js')
            .then(function(response) { return response.json(); })
            .then(function(cart) {
              const freeGift = findFreeGift(cart);
              if (freeGift) {
                console.log('[Auto Free Gift] Removing free gift - promo limit reached');
                removeFreeGift(freeGift.key);
              } else {
                isUpdatingFreeGift = false;
              }
            });
        }

        // Promo still active - proceed with normal logic
        return fetch(window.routes.cartUrl + '.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            const bagCount = countBagsInCart(cart);
            const freeGift = findFreeGift(cart);

            console.log('[Auto Free Gift] Bag count:', bagCount, 'Free gift:', freeGift);

            if (bagCount > 0) {
              if (!freeGift) {
                // Add free gift
                console.log('[Auto Free Gift] Adding free gift with quantity:', bagCount);
                addFreeGift(bagCount);
              } else if (freeGift.quantity !== bagCount) {
                // Update quantity
                console.log('[Auto Free Gift] Updating free gift from', freeGift.quantity, 'to', bagCount);
                updateFreeGiftQuantity(freeGift.key, bagCount);
              } else {
                isUpdatingFreeGift = false;
              }
            } else {
              // If no bags in cart, leave free gift alone (customer keeps it)
              console.log('[Auto Free Gift] No bags in cart, but leaving free gift');
              isUpdatingFreeGift = false;
            }
          });
      })
      .catch(function(error) {
        console.error('[Auto Free Gift] Error in updateFreeGift:', error);
        isUpdatingFreeGift = false;
      });
  }

  // Add free gift to cart
  function addFreeGift(quantity) {
    fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: FREE_GIFT_VARIANT_ID,
          quantity: quantity,
          properties: {
            '_free_gift': 'true',
            '_note': 'Free gift - 1 per bag purchased',
            '_original_price': (FREE_GIFT_ORIGINAL_PRICE / 100).toFixed(2), // Store original price for display
            '_discount_amount': (FREE_GIFT_DISCOUNT_AMOUNT / 100).toFixed(2) // Store discount for display
          }
        }]
      })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      console.log('[Auto Free Gift] Successfully added');
      refreshCart();
    })
    .catch(function(error) {
      console.error('[Auto Free Gift] Error adding:', error);
      isUpdatingFreeGift = false;
    });
  }

  // Update free gift quantity
  function updateFreeGiftQuantity(lineKey, newQuantity) {
    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: lineKey,
        quantity: newQuantity
      })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      console.log('[Auto Free Gift] Successfully updated quantity');
      refreshCart();
    })
    .catch(function(error) {
      console.error('[Auto Free Gift] Error updating:', error);
      isUpdatingFreeGift = false;
    });
  }

  // Remove free gift from cart
  function removeFreeGift(lineKey) {
    fetch(window.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        line: lineKey,
        quantity: 0
      })
    })
    .then(function(response) { return response.json(); })
    .then(function() {
      console.log('[Auto Free Gift] Successfully removed');
      refreshCart();
    })
    .catch(function(error) {
      console.error('[Auto Free Gift] Error removing:', error);
      isUpdatingFreeGift = false;
    });
  }

  // Refresh cart display
  function refreshCart() {
    // Trigger theme's cart refresh event
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));

    isUpdatingFreeGift = false;
  }

  // Listen for product added to cart
  document.addEventListener('product:added', function(event) {
    console.log('[Auto Free Gift] Product added event triggered');
    setTimeout(updateFreeGift, 500); // Small delay to ensure cart is updated
  });

  // Listen for cart refresh events
  document.addEventListener('cart:refresh', function(event) {
    if (!isUpdatingFreeGift) {
      console.log('[Auto Free Gift] Cart refresh event triggered');
      setTimeout(updateFreeGift, 500);
    }
  });

  // Check on page load
  document.addEventListener('DOMContentLoaded', function() {
    console.log('[Auto Free Gift] Checking cart on page load');
    setTimeout(updateFreeGift, 1000);
  });

  console.log('[Auto Free Gift] System initialized');

// =====================================================================
// Customize It modal — Chrome aria-hidden focus block fix (2026-05-19, v2)
// =====================================================================
// Some third-party widget sets aria-hidden="true" on <main id="main">
// at page load (before any modal opens). Chrome 124+ blocks keyboard
// input on focused elements inside aria-hidden subtrees, so users can't
// type in Line 1 of the Customize It modal (which lives inside <main>).
// v2: strip unconditionally on load AND on every subsequent set, since
// the third party sets aria-hidden BEFORE the modal opens. Modal styles
// (theme.css) key off `.modal[aria-hidden]`, not main's, so removing
// main's aria-hidden does not affect modal appearance.
// =====================================================================
(function () {
  var mainEl = document.getElementById('main');
  if (!mainEl) return;
  function strip() {
    if (mainEl.hasAttribute('aria-hidden')) {
      mainEl.removeAttribute('aria-hidden');
    }
  }
  strip();
  new MutationObserver(strip).observe(mainEl, {
    attributes: true,
    attributeFilter: ['aria-hidden']
  });
})();
})();